export default __webpack_public_path__ + "static/media/dacott.8946c4ad.png";